export default async function procLine(params) {
    const { app, w, h, cards } = params;

    // Stack cards
    let pArr = cards.map((card, i) => {
        const x = w / 2;
        const y = h * 0.8 - i * 2;
        return anime({targets: card, x, y, duration: 750, easing: 'linear'}).finished
    });
    await Promise.all(pArr);

    // Line up the cards
    pArr = cards.map((card, i) => {
        const max = cards.length - 1;
        const x = w * 0.1 + w * 0.8 * (i / max);
        const y = h * 0.4;
        card.zIndex = max - i;
        return anime({targets: card, x, y, duration: 750, easing: 'linear'}).finished
    });
    await Promise.all(pArr);
}
